export enum DrugDeliveryAction {
  APPLY = 'Apply',
  GIVE = 'Give',
  INJECT = 'Inject',
  INSERT = 'Insert',
  INSTILL = 'Instill',
}
